import { Link } from 'react-router-dom';
import ArticleLayout from '@/components/ArticleLayout';

export default function AboutPage() {
  return (
    <ArticleLayout
      title="About CSSBuy Spreadsheet"
      description="Learn about our independent informational resource for CSSBuy research and product discovery."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'About', to: '/about' },
      ]}
      lastUpdated="2026-08-30"
    >
      <h2>Our Mission</h2>
      <p>
        CSSBuy Spreadsheet is an independent informational resource dedicated to helping buyers research and discover products through organized guides, comparisons, and practical tips. We are not affiliated with or endorsed by CSSBuy.
      </p>

      <h2>What We Do</h2>
      <p>
        We provide organized information about CSSBuy-related resources, including product categories, buying guides, QC guides, shipping information, and safety tips. Our goal is to help users make informed decisions before purchasing.
      </p>

      <h2>What We Do Not Do</h2>
      <ul>
        <li>We do not process payments, orders, or refunds.</li>
        <li>We do not handle shipping or logistics.</li>
        <li>We do not guarantee product quality or seller reliability.</li>
        <li>We are not the official CSSBuy website.</li>
      </ul>

      <h2>Editorial Policy</h2>
      <p>
        We do not fabricate prices, inventory, sales numbers, reviews, discount codes, QC results, or shipping times. All information is presented for research purposes only. Users should always verify current information on the official CSSBuy website before making any purchase decisions.
      </p>

      <h2>Contact</h2>
      <p>
        For questions or suggestions, please visit our <Link to="/contact">contact page</Link>.
      </p>
    </ArticleLayout>
  );
}